import React, { ReactNode } from "react";

interface SuccessPopupProps {
  onClose?: () => void;
  content?: ReactNode;
  actions?: ReactNode;
}

const SuccessPopup: React.FC<SuccessPopupProps> = ({ onClose, content, actions }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4">
      <div className="bg-white w-[641px] min-h-[400px] md:min-h-[400px] rounded-3xl flex flex-col px-6 py-8 justify-between">
        {/* Green Dashed Content Area */}
        <div className="border border-dashed border-green-400 rounded-3xl bg-[#E6F4EA] flex flex-col items-center justify-center flex-grow text-center px-6 py-8">
          {content}
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4 pt-6">
          {actions}
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;

